export default __webpack_public_path__ + "static/media/scan.1cf0c513.png";